import { render, staticRenderFns } from "./hotLiveList.vue?vue&type=template&id=6ec81b72&scoped=true"
import script from "./hotLiveList.vue?vue&type=script&lang=js"
export * from "./hotLiveList.vue?vue&type=script&lang=js"
import style0 from "./hotLiveList.vue?vue&type=style&index=0&id=6ec81b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec81b72",
  null
  
)

export default component.exports